import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface MainProps extends ComponentPropsWithoutRef<"main"> {
  children: ReactNode;
  className?: string;
}

export const Main = ({ children, className, ...rest }: MainProps) => (
  <main
    className={classNames(
      "text-default bg-secondary relative flex overflow-hidden [grid-area:main]",
      className,
    )}
    {...rest}
  >
    {children}
  </main>
);
